// extracted by mini-css-extract-plugin
export var infoItem = "_py-2";
export var title = "_py-0";
export var value = "_py-1";